export default __webpack_public_path__ + "static/media/doc2.f3f25f7f.jpg";